import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import { translate } from 'react-i18next';

import UnitMap from '../UnitMap/UnitMap';

const UnitInfo = ({ unit, notes, pathNamespace, t }) => (
  <Grid fluid className="unit-info">
    <Row className="unit-info-address">
      <Col xs={12} sm={12} md={6} lg={6} mdPush={6} lgPush={6}>
        <div className="unit-details">
          <h3>
            {unit.name}<br />
            {unit.address}<br />
            {unit.postcode} {unit.city}
          </h3>
          {notes &&
          <p>{notes}</p>
          }
        </div>
      </Col>
      <Col
        className="unit-map"
        xs={12} sm={12} md={6} lg={6} mdPull={6} lgPull={6}
      >
        <UnitMap unit={unit} />
      </Col>
    </Row>
    <div className="unit-info-general-text">
      <h3>{t(`${pathNamespace}:instructionsForReservationTitle`)}</h3>
      <p>{t(`${pathNamespace}:instructionsForReservationText`)}</p>
    </div>
  </Grid>
);

UnitInfo.propTypes = {
  unit: PropTypes.shape({}).isRequired,
  notes: PropTypes.string,
  pathNamespace: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
};

UnitInfo.defaultProps = {
  pathNamespace: '',
  notes: null
};

export default translate(props => ['common', 'booking', props.pathNamespace])(UnitInfo);



// WEBPACK FOOTER //
// ./src/containers/UnitInfo/UnitInfo.jsx